export const SET_FORM_CONTROL = "SET_FORM_CONTROL";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_IS_FORM_VALID = "SET_IS_FORM_VALID";
export const CLEAR_FORM_CONTROLS = "CLEAR_FORM_CONTROLS";
export const TOGGLE_RECOVERY_PASSWORD = "TOGGLE_RECOVERY_PASSWORD";
export const SET_SAVE_USER = "SET_SAVE_USER";
export const SET_IS_SUBMIT_ACTIVE = "SET_IS_SUBMIT_ACTIVE";
